import styled from 'styled-components'

export const Stamp = styled.div`
  background-image: url('/assets/img/stamps/troca-com-troco.svg');
  background-repeat: no-repeat;
  background-size: 100%;
  width: ${props => (props.daInfo ? '25px' : '14px')};
  height: ${props => (props.daInfo ? '49px' : '25px')};

  div {
    transition: opacity 0.2s;
    opacity: 0;
    pointer-events: none;
  }
  &:hover {
    div {
      opacity: 1;
    }
  }
`

export const Tooltip = styled.div`
  position: absolute;
  right: 0;
  top: -4px;
  transform: translateY(-100%);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 10px;
  padding: 8px;
  white-space: nowrap;
  border-radius: 4px;
  box-sizing: border-box;
`
